export const PREDEFINED_CERTIFICATES = [
  'PKW Führerschein Klasse B',
  'LKW Führerschein Klasse C CE',
  'TOEFL Test of English as a Foreign Language',
  'Erste Hilfe Kurs',
  'Gesundheitszeugnis'
];
